import { z } from 'zod';

import {
  LEGACY_OPERATION_TASK_TAB_ACTIVE,
  OperationTaskTab,
} from './-constants';

const operationTaskTabValues = [
  OperationTaskTab.IN_PROGRESS,
  OperationTaskTab.NOT_STARTED,
  OperationTaskTab.WAITING_APPROVAL,
  OperationTaskTab.COMPLETED,
  OperationTaskTab.ALL,
] as const;

export const SearchSchema = z.object({
  taskTab: z
    .union([
      z.enum(operationTaskTabValues),
      z.literal(LEGACY_OPERATION_TASK_TAB_ACTIVE),
    ])
    .transform((value) =>
      value === LEGACY_OPERATION_TASK_TAB_ACTIVE
        ? OperationTaskTab.IN_PROGRESS
        : value,
    )
    .default(OperationTaskTab.IN_PROGRESS)
    .catch(OperationTaskTab.IN_PROGRESS),
  page: z.number().int().min(1).default(1).catch(1),
  pageSize: z.number().int().min(1).default(20).catch(20),
});
